// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/ai-performance/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/ai-performance/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "AI Performance" })
  return <Page />
}
